// extracted by mini-css-extract-plugin
export default {"recordDetailContainer":"RecordDetail_recordDetailContainer__zL7zT","detailLabel":"RecordDetail_detailLabel__s-pbo","detailData":"RecordDetail_detailData__KN1V2"};